/*
 eslint-disable
 @typescript-eslint/consistent-type-assertions,
 @angular-eslint/no-inputs-metadata-property,
*/

import { Component } from '@angular/core';

import type { LocationBrief } from '@recruitee/locations-types';
import { TruncateComponent } from '@recruitee/user-interface';

@Component({
  imports: [TruncateComponent],
  selector: 'rt-location-name-cell',
  template: `
    @for (location of locations; track trackById($index, location)) {
      <rt-truncate>
        {{ location.name }}
      </rt-truncate>
    }
  `,
  styleUrls: ['./location-name-cell.component.less'],
  host: {
    '[class]': '"location-names-container"',
  },
  inputs: LocationNameCellComponent.NgInputs,
})
export class LocationNameCellComponent {
  public static NgInputs = ['locations' as const];

  public locations: LocationBrief[];

  public trackById = (index: number, item: LocationBrief) => item.id;
}
